import React, { useRef, useState } from 'react';
import { Stack, TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';

import ApprovalSelect from './tablelist/ApprovalSelect';
import {
  AddButton,
  UpdateButton,
} from '../../components/common/button/CustomButtons';
import ChildHeader from '../../components/ui/ChildHeader';
import { SearchFilterContainer } from '../../assets/styles/layout/searchFilter.styled';
import FilterBy from '../../components/common/FilterBy';
import { SearchBar } from '../../components/common/SearchBar';
import {
  CustomPagination,
  StatePagination,
  TableCustom,
} from '../../components/common';
import useDebounce from '../../hooks/useDebounce';
import {
  EditIconButton,
  DeleteIconButton,
  ViewIconButton,
  AddIconButton,
  CardIconButton,
} from '../../components/common/button/CustomIconButton';
import Create from './Create';
import ModalCustom from '../../components/common/Modal';
import { useQuery } from '../../hooks/UseQuery';
import useConfirm from '../../components/common/useConfirm';

import { IData } from './Interface';
import { Loader } from '../../components/common/Loader';
import CustomUploadButton from '../../components/common/button/CustomUploadButton';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../services/auth/AuthProvider';

const tableHeaderObj = [
  [
    { text: '#', rowspan: 1, colspan: 1 },
    { text: 'TOOL DETAILS', rowspan: 1, colspan: 1 },
    { text: 'Status', rowspan: 1, colspan: 1 },
    { text: 'Action', rowspan: 1, colspan: 1 },
    { text: 'Update', rowspan: 1, colspan: 1 },
  ],
];
const statusObj = {
  pending: 1,
  accepted: 2,
  rejected: 3,
};
const filterOptions = [{ value: 'createdAt', name: 'Most Recent First' }];

const List = () => {
  const [data, setData] = useState<IData[]>([]);
  const [isModal, setIsModal] = useState<boolean>(false);
  const [render, setRender] = useState(false);
  const [machineId, setMachineId] = useState<string | null>(null);
  const [perPage, setPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const search = useQuery('search');
  const filter = useQuery('filter');
  const page = useQuery('page') || 1;
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const idRef = useRef('');
  const navigate = useNavigate();
  const { state } = useAuth();

  const [DialogDelete, confirmDelete] = useConfirm(
    'DELETE ',
    'Are you sure you want to delete this?'
  );
  const fetchData = async () => {
    const res = await axios
      .get(
        `/api/masterListOfTools?page=${page}&sortBy=${filter}&search=${search}&perPage=${perPage}`
      )
      .catch((err) => {
        console.log(err);
      });
    setData(res?.data?.results);
    setPerPage(res?.data?.perPage);
    setTotalPages(res?.data?.pages);
  };

  const deleteCustomer = async (id: string) => {
    const ans = await confirmDelete();
    if (!ans) return;
    await axios
      .delete(`/api/masterListOfTools/${id}`)
      .then((res) => {
        alert('Document deleted successfully');
        setRender((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };

  useDebounce(fetchData, 500, [page, search, render, isModal]);

  const handleChangeStatus = (
    e: React.ChangeEvent<HTMLSelectElement>,
    documentIndex: number
  ) => {
    const values = [...data];
    values[documentIndex].is_admin_request = null;
    values[documentIndex].is_admin_request_no = +e.target.value;
    setData(values);
  };

  const updateStatus = async (id: string, documentIndex: number) => {
    let isConfirm = window.confirm('Are you sure you want to update status');
    if (isConfirm && data.length > 0) {
      axios
        .patch(`/api/masterListOfTools/updateStatus/${id}`, {
          is_admin_request_no: data[documentIndex].is_admin_request_no,
          report_approved_by: state.user?.name,
        })
        .then((res) => {
          if (res.data.status === 'success') {
            alert('Status Change successfully');
          }
          setRender((prev) => !prev);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <>
      <ChildHeader text="TOOLS LIST">
        <AddButton onClick={() => setIsModal(true)} label="New TOOLS" />
      </ChildHeader>
      <SearchFilterContainer filter={true}>
        <SearchBar label="Search" />
        <FilterBy options={filterOptions} />
      </SearchFilterContainer>
      <Loader loader={isLoading} />
      <TableCustom tableHeaderObj={tableHeaderObj}>
        <TableBody>
          {data &&
            data.map((item: IData, index: number) => (
              <React.Fragment key={item._id}>
                <TableRow>
                  <TableCell align="center">
                    {perPage * (+page - 1) + index + 1}
                  </TableCell>
                  <TableCell align="center">{item?.tool_details}</TableCell>

                  <TableCell align="center">
                    <ApprovalSelect
                      document={item}
                      documentIndex={index}
                      {...{
                        handleChangeStatus,
                        statusObj,
                        state,
                      }}
                    />
                  </TableCell>

                  <TableCell>
                    <Stack direction="row" sx={{ justifyContent: 'center' }}>
                      {/* <CardIconButton
                        tooltipTitle="Tools History"
                        onClick={() => {
                          navigate(`/common/toolsHistory/${item._id}`);
                        }}
                      /> */}
                      <EditIconButton
                        tooltipTitle="EDIT"
                        onClick={() => {
                          setMachineId(item?._id || '');
                          setIsModal(true);
                        }}
                      />

                      <DeleteIconButton
                        tooltipTitle="DELETE"
                        onClick={() => {
                          deleteCustomer(item?._id || '');
                        }}
                      />
                    </Stack>
                  </TableCell>
                  <TableCell align="center">
                    <UpdateButton
                      label="update"
                      size="small"
                      onClick={() => updateStatus(item?._id || '', index)}
                    />
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
        </TableBody>
      </TableCustom>
      <CustomPagination totalPage={totalPages} />
      <ModalCustom
        openModal={isModal}
        closeModal={() => {
          setMachineId(null);
          setIsModal(false);
        }}
        title="CREATE NEW TOOLS"
      >
        <Create id={machineId} setIsModal={setIsModal} />
      </ModalCustom>
      <DialogDelete isSubmitContent={false} />
    </>
  );
};

export default List;
